var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0711 0.848635C4.75388 0.848635 1.25391 4.3486 1.25391 8.66583C1.25391 16.483 10.4924 23.5896 15.467 25.2425C20.4416 23.5896 29.6801 16.483 29.6801 8.66583C29.6801 4.3486 26.1801 0.848635 21.8629 0.848635C19.2192 0.848635 16.8812 2.16121 15.467 4.17023C14.7462 3.14348 13.7885 2.30554 12.6752 1.72735C11.5619 1.14916 10.3256 0.847748 9.0711 0.848635Z",
    stroke: "white",
    strokeWidth: 1.3731,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart_2.e6cc2bc0e5f47455d2144e2391b74342.svg";
export { ForwardRef as ReactComponent };